import React from "react";
import { Modal, Button, Container, Row, Col } from "react-bootstrap";
import "./BidDetailsModal.css"; // Custom styles

const BidDetailsModal = ({
  show,
  handleClose,
  bidDetailsById,
  propertyCategory,
}) => {
  // console.log("bidDetailsById", bidDetailsById);

  const getFormatPrice = (amount) => {
    if (amount?.length === 0 || isNaN(amount)) {
      return "";
    }
    return amount?.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
  };

  const getNoteText = () => {
    let note = "";

    if (propertyCategory === "8") {
      note = `Note: The total price will include the Transcation Fee (${
        bidDetailsById?.buyerPremiumPercentage !== null
          ? bidDetailsById?.buyerPremiumPercentage + "%"
          : "0%"
      } of Bid Amount)`;
    } else if (propertyCategory === "4") {
      note = `Note: After the auction ends, sale deposit amount of ${bidDetailsById?.saleDepositAmount} is to be wired to the title company by 12 PM Eastern Time the following business day`;
    } else {
      note = `Note: The total price will include the Buyer's Premium (${
        bidDetailsById?.buyerPremiumPercentage !== null
          ? bidDetailsById?.buyerPremiumPercentage + "%"
          : "0%"
      } of Bid Amount)`;
    }

    return note;
  };
  const calculatePercentageOfBid = () => {
    if (
      !bidDetailsById?.loanAmount ||
      !bidDetailsById?.biddingCost?.currentBidAmount
    )
      return null;
    const percentage = (
      (bidDetailsById?.loanAmount /
        bidDetailsById?.biddingCost?.currentBidAmount) *
      100
    ).toFixed(2);
    return `${percentage}%`;
  };
  return (
    <Modal show={show} onHide={handleClose} size="lg" className="">
      <Modal.Header
        closeButton
        className="border-bottom py-3 add-agent-license"
      >
        <Modal.Title className="p-1 mb-0 add-agent-license-title roboto-regular">
          Bid Details
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="sectionContainer pt20">
          <Row xs={12} md={12}>
            <Col xs={6} md={6}>
              <div className=" row">
                <p className="detail-label">Property ID: </p>
                <p className="detail-value pl5">
                  {" " + bidDetailsById?.propertyId}
                </p>
              </div>
            </Col>
            <Col xs={6} md={6}>
              <div className=" row">
                <p className="detail-label">Bid Date: </p>
                <p className="detail-value pl5">
                  {" " + bidDetailsById?.formattedSubbmittedDate}
                </p>
              </div>
            </Col>
          </Row>
          <Col xs={6} md={6}>
            <div className=" row">
              <p className="detail-label">Bid Type: </p>
              <p className="detail-value pl5">
                {" " + bidDetailsById?.biddingType}
              </p>
            </div>
          </Col>
        </div>

        <div className="seperator prpl20"></div>
        <p className="headingTitle">Financing Information</p>

        <div className="sectionContainer">
          <Row xs={12} md={12}>
            <Col xs={6} md={6}>
              <div className=" row">
                <p className="detail-label">Payment Method: </p>
                <p className="detail-value pl5">
                  {" " + bidDetailsById?.paymentType}
                </p>
              </div>
            </Col>
            {bidDetailsById?.propertyCategory !== "FORECLOSURE" && (
              <Col xs={6} md={6}>
                <div className=" row">
                  <p className="detail-label">Must Close Within:</p>
                  <p className="detail-value pl5">
                    {" " + bidDetailsById?.closingDaysSelected + " Days"}
                  </p>
                </div>
              </Col>
            )}
          </Row>
          {bidDetailsById?.paymentType === "MORTGAGE" && (
            <>
              <Row xs={12} md={12}>
                <Col xs={6} md={6}>
                  <div className=" row">
                    <p className="detail-label">Type of Financing: </p>
                    <p className="detail-value pl5">
                      {" " + bidDetailsById?.mortgageType}
                    </p>
                  </div>
                </Col>
                <Col xs={6} md={6}>
                  <div className=" row">
                    <p className="detail-label">Loan Amount: </p>
                    <p className="detail-value pl5">
                      {" $" + getFormatPrice(bidDetailsById?.loanAmount)}({" "}
                      {calculatePercentageOfBid()}){" "}
                    </p>
                  </div>
                </Col>
              </Row>
              <Row xs={12} md={12}>
                <Col xs={6} md={6}>
                  <div className=" row">
                    <p className="detail-label">Bid Contingent On: </p>
                    <p className="detail-value pl5">
                      {bidDetailsById?.contingentUponFlag === "N"
                        ? "No"
                        : "Yes"}
                    </p>
                  </div>
                </Col>

                <Col xs={6} md={6}>
                  <div className=" row">
                    <p className="detail-label">Pre Approved for Financing</p>
                    <p className="detail-value pl5">
                      {bidDetailsById?.preApprovalDetail
                        ?.isPreApprovedForFinance === false
                        ? "No"
                        : "Yes"}
                    </p>
                  </div>
                </Col>
              </Row>
              {/* <Row xs={12} md={12}>
                <Col xs={6} md={6}>
                  <div className=" row">
                    <p className="detail-label">Institution Name: : </p>
                    <p className="detail-value pl5">
                      {" " + bidDetailsById?.preApprovalDetail?.institutionName}
                    </p>
                  </div>
                </Col>

                <Col xs={6} md={6}>
                  <div className=" row">
                    <p className="detail-label">Pre Approved Amount</p>
                    <p className="detail-value pl5">
                      {" $" +
                        getFormatPrice(
                          bidDetailsById?.preApprovalDetail?.preApprovedAmount
                        )}
                    </p>
                  </div>
                </Col>
              </Row> */}
              <Row xs={12} md={12}>
                {bidDetailsById?.preApprovalDetail?.institutionName && (
                  <Col xs={6} md={6}>
                    <div className="row">
                      <p className="detail-label">Institution Name:</p>
                      <p className="detail-value pl5">
                        {" " +
                          bidDetailsById?.preApprovalDetail?.institutionName}
                      </p>
                    </div>
                  </Col>
                )}

                {bidDetailsById?.preApprovalDetail?.preApprovedAmount > 0 && (
                  <Col xs={6} md={6}>
                    <div className="row">
                      <p className="detail-label">Pre Approved Amount</p>
                      <p className="detail-value pl5">
                        {" $" +
                          getFormatPrice(
                            bidDetailsById?.preApprovalDetail?.preApprovedAmount
                          )}
                      </p>
                    </div>
                  </Col>
                )}
              </Row>
            </>
          )}
          <Row xs={12} md={12}>
            {bidDetailsById?.propertyCategory !== "FORECLOSURE" && (
              <Col xs={6} md={6}>
                <div className=" row">
                  <p className="detail-label">Have you Toured the Property?:</p>
                  <p className="detail-value pl5">
                    {bidDetailsById?.propertyVisted === true ? " Yes" : " No"}
                  </p>
                </div>
              </Col>
            )}

            {bidDetailsById?.buyerPremiumPercentage !== null &&
              bidDetailsById?.buyerPremiumPercentage !== 0 && (
                <Col xs={6} md={6}>
                  <div className=" row">
                    <p className="detail-label">Premium Percent:</p>
                    <p className="detail-value pl5">
                      {bidDetailsById?.buyerPremiumPercentage !== null
                        ? bidDetailsById?.buyerPremiumPercentage + "%"
                        : "0%"}
                    </p>
                  </div>
                </Col>
              )}
          </Row>
        </div>

        {bidDetailsById?.bidContingencyList?.length > 0 && (
          <>
            <div className="seperator prpl20"></div>
            <p className="headingTitle">Seller Contingencies</p>

            {bidDetailsById?.bidContingencyList.map((item, index) => (
              <div key={index}>
                <p className="contingenciesText">
                  {" \u2022   " + item?.contigencyDescription}
                </p>
              </div>
            ))}
          </>
        )}

        <div className="seperator prpl20"></div>
        {<p className="note">{getNoteText()}</p>}

        {bidDetailsById?.emdAmount &&
          bidDetailsById?.propertyCategory !== "SHRT_SALE" && (
            <p className="note">
              An earnest money deposit of $
              {getFormatPrice(bidDetailsById?.emdAmount)} is due after you sign
              the Purchase & Sale Agreement. At closing, this amount will be
              credited towards your total purchase price.
            </p>
          )}
      </Modal.Body>
    </Modal>
  );
};

export default BidDetailsModal;
